import React from "react";
import chevronSrc from "../assets/sidebar/chevron.svg";

// Icons of the organizer panel come from Figma as ready-made SVG files: they are shown as images,
// never inlined or redrawn. The size attributes keep each icon at the box the frame gives it.
export const SidebarIcon = ({ src, width, height = width }) => (
  <img src={src} width={width} height={height} alt="" aria-hidden="true" />
);

// Chevron of an expandable row. It points down in the file; CSS turns it to point right while the
// row is closed (see `.organizer-module__chevron`).
export const SidebarChevron = () => (
  <img className="organizer-module__chevron" src={chevronSrc} width="14" height="7.98" alt="" aria-hidden="true" />
);
